<template>
    <div class="header">
        <nav>
            <ul>
                <li>
                    <button type="button" @click="handleLogOut()">ログアウト</button>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
    "use strict";

    export default {
        "methods": {
            handleLogOut() {
                this.$router.push({ "name": "offices_logout" });
            },
        },
    };
</script>
